import handleError from "./handle-error";
import api from "../api";
import axios from "../utils/axios.instance";

export const getCandidateDetails = async (payload) => {
  try {
    const { data } = await axios.get(api.getCandidateDetails, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const updateCandidateProfile = async (payload) => {
  try {
    const { data } = await axios.patch(api.updateCandidateProfile, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};


export const getRestrictedCandidateDetails = async (candidateId) => {
  try {
    const { data } = await axios.get(
      api.getRestrictedCandidate + "/" + candidateId
    );
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const addCandidate = async (payload) => {
  try {
    const { data } = await axios.post(api.addCandidate, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const updateCandidate = async (payload) => {
  try {
    const { data } = await axios.patch(api.updateCandidate, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getCandidates = async (payload) => {
  try {
    const { data } = await axios.post(api.getCandidates, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getRegisterCandidates = async (payload) => {
  try {
    const { data } = await axios.get(api.getRegisterCandidates, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getCandidateAssessment = async (payload) => {
  try {
    const { data } = await axios.get(api.getCandidateAssessment, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

// Skills
export const addSkill = async (payload) => {
  try {
    const { data } = await axios.post(api.addSkill, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const updateSkill = async (payload) => {
  try {
    const { data } = await axios.patch(api.updateSkill, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const deleteSkill = async (id) => {
  try {
    const { data } = await axios.delete(api.deleteSkill + "/" + id);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const listSkill = async () => {
  try {
    const { data } = await axios.get(api.listSkill + "?type=1");
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getSkills = async (candidateId) => {
  try {
    const { data } = await axios.get(
      api.listSkill + `?type=1&candidateId=${candidateId}`
    );
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getReferral = async () => {
  try {
    const { data } = await axios.get(api.getReferral);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getReferralRequests = async () => {
  try {
    const { data } = await axios.get(api.getReferralRequests);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const addNewReferral = async (payload) => {
  try {
    const { data } = await axios.post(api.addNewReferral, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const deleteReferral = async (_id) => {
  try {
    const { data } = await axios.delete(api.deleteReferral + `/${_id}`);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const removeReferral = async (_id) => {
  try {
    const { data } = await axios.delete(api.removeReferral + `/${_id}`);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const finalConfirmation = async (payload) => {
  try {
    const { data } = await axios.post(api.finalConfirmation, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getMessagesList = async (_id) => {
  try {
    const { data } = await axios.get(api.getMessagesList + `/${_id}`);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const sendMessage = async (payload) => {
  try {
    const { data } = await axios.post(api.sendMessage, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const jobMatchesSkills = async (candidateId, jobId) => {
  try {
    const { data } = await axios.get(
      api.contactMatchesSkills + `/${candidateId}/${jobId}`
    );

    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const addAspiration = async (payload) => {
  try {
    const { data } = await axios.post(api.contactAspirationAdd, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getAspirationDetail = async () => {
  try {
    const { data } = await axios.get(api.getContactAspirationAdd);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const updateAspiration = async (payload) => {
  try {
    const { data } = await axios.patch(
      api.updateContactAspiration + `/${payload._id}`,
      payload
    );
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const updatePrivacy = async (payload) => {
  try {
    const { data } = await axios.patch(api.updatePrivacy, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const updatePrivacyReqest = async (payload) => {
  try {
    const { data } = await axios.patch(
      api.updateRequestPrivacySetting,
      payload
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
